import { Column } from "react-table";
import { TableCustomHeader } from "../../component/table/components/TableCustomHeader";
import { TableCustomCell } from "../../component/table/components/TableCustomCell";
import { IOrganization } from "../models/OrganizationModels";

export const COLUMNS: ReadonlyArray<Column<IOrganization>> = [
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="STT"
        className="text-center text-light spaces W-40"
      />
    ),
    id: "stt",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center "
        data={props.data[props.row.index].stt}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Tên"
        className="text-center text-light spaces min-w-200"
      />
    ),
    id: "name",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center"
        data={props.data[props.row.index].name}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Mã"
        className="text-center text-white align-middle bg-pri spaces min-w-50"
      />
    ),
    id: "code",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].code}
      />
    ),
  },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Website"
        className="text-center text-white align-middle bg-pri min-w-200px"
      />
    ),
    id: "website",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="s-2"
        data={props.data[props.row.index].website}
      />
    ),
  },
  // {
  //   Header: (props) => (
  //     <TableCustomHeader<any>
  //       tableProps={props}
  //       title="Đơn vị cha"
  //       className="text-center text-white align-middle bg-pri spaces min-w-150"
  //     />
  //   ),
  //   id: "parentUnit",
  //   Cell: ({ ...props }) => (
  //     <TableCustomCell
  //       className="text-center"
  //       data={props.data[props.row.index].parentUnit}
  //     />
  //   ),
  // },
  {
    Header: (props) => (
      <TableCustomHeader<any>
        tableProps={props}
        title="Địa chỉ"
        className="text-center text-white align-middle bg-pri spaces min-w-200"
      />
    ),
    id: "addressFull",
    Cell: ({ ...props }) => (
      <TableCustomCell
        className="text-center"
        data={props.data[props.row.index].addressFull}
      />
    ),
  },
];
